import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://compliance-backend.cloudsanalytics.ai';
const API_TIMEOUT = parseInt(process.env.REACT_APP_API_TIMEOUT, 10) || 30000;

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: API_TIMEOUT,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
  withCredentials: false,
});

// Add request interceptor for Cognito token authentication
api.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem('cognito_token');
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Add response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);

// API service functions
export const apiService = {
  // Agents endpoints
  getAllAgents: async () => {
    const response = await api.get('/agents/');
    return response.data;
  },

  getAgentById: async (agentId) => {
    const response = await api.get(`/agents/${agentId}/`);
    return response.data;
  },

  // Alerts endpoints
  getAllAlerts: async () => {
    const response = await api.get('/alerts/');
    return response.data;
  },

  getAlertsByAgentId: async (agentId) => {
    const response = await api.get(`/alerts/${agentId}/`);
    return response.data;
  },

  // Vulnerabilities endpoints
  getAllVulnerabilities: async () => {
    const response = await api.get('/vulnerabilities/');
    return response.data;
  },

  getVulnerabilitiesByAgentId: async (agentId) => {
    const response = await api.get(`/vulnerabilities/${agentId}/`);
    return response.data;
  },

  // SCA endpoint
  getSCAData: async (agentId) => {
    const response = await api.get(`/sca/${agentId}/`);
    return response.data;
  },

  // Events evolution endpoint
  getEventsEvolution: async (agentId, interval = '30m', days = 30) => {
    const response = await api.get(`/events/agent/${agentId}/evolution?interval=${interval}&days=${days}/`);
    return response.data;
  },

  // MITRE endpoint
  getMitreData: async (agentId, days = 30) => {
    const response = await api.get(`/mitre/?agent_id=${agentId}&days=${days}/`);
    return response.data;
  },
};

export default api;
